import { RefiMbox } from './mbox.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../adobe-target/adobe-target.js';
import '../../utils/load-script.js';
import '../../utils/wait-for-dom.js';
import '../../utils/refi-mfe-uuid.js';
import '../../utils/track-analytics-event.js';

defineRefiElement('refi-common-mbox', RefiMbox);
